




































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["accountBook"]),
})
export default class ReportMargin extends Vue {
    @Prop({ type: Number })
    margin!: number;

    @Prop({ type: Number })
    padding!: number;

    startY = 0;
    endY = 0;
    startX = 0;
    endX = 0;
    startDrag(e: any) {
        this.startY = e.y;
    }

    startDragLeft(e: any) {
        this.startX = e.x;
    }

    paddingLr = this.$store.state.sheet.left;
    get cmHeight(): string {
        return ((this.$store.state.sheet.top / 72) * 2.54).toFixed(2);
    }
    get cmLeft(): string {
        return ((this.$store.state.sheet.left / 72) * 2.54).toFixed(2);
    }
    get cmRight(): string {
        return ((this.$store.state.sheet.right / 72) * 2.54).toFixed(2);
    }
    @Watch("cmHeight")
    marginChanged(val: string) {
        this.showTop = val;
    }
    @Watch("cmLeft")
    leftChanged(val: string) {
        this.showLeft = val;
    }
    @Watch("cmRight")
    rightChanged(val: string) {
        this.showRight = val;
    }
    showTop = "45";
    showLeft = "30";
    showRight = "30";
    async mounted() {
        this.showTop = ((this.$store.state.sheet.top / 72) * 2.54).toFixed(2);
        this.showLeft = ((this.$store.state.sheet.left / 72) * 2.54).toFixed(2);
        this.showRight = ((this.$store.state.sheet.right / 72) * 2.54).toFixed(2);
    }
    saveChange() {
        Vue.axios
            .post(`accounts/printer/set/save`, {
                sheet: JSON.stringify(this.sheet),
                accounterId: this.$store.state.account.id,
            })
            .then((res) => { });
    }
    sheet = {
        top: this.$store.state.sheet.top,
        left: this.$store.state.sheet.left,
        right: this.$store.state.sheet.right,
    };
    changeTop() {
        let top = +this.showTop;
        if (+this.showTop < 0) {
            this.showTop = "0";
            top = 0;
            this.sheet.top = top;
            this.$store.dispatch("sheetChangeTop", top);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.saveChange();
        } else {
            top = (+top / 2.54) * 72;
            if (top > 100) {
                top = 100;
                this.showTop = (
                    (+this.$store.state.sheet.top / 72) *
                    2.54
                ).toFixed(2);
            }
            this.sheet.top = top;
            this.$store.dispatch("sheetChangeTop", top);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.saveChange();
        }
    }
    changeLeft() {
        let Left = +this.showLeft;
        if (+this.showLeft < 0) {
            Left = 0;
            this.showLeft = "0";
            this.sheet.left = Left;
            this.$store.dispatch("sheetChangeLeft", Left);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.saveChange();
            this.$forceUpdate();
        } else {
            Left = (+Left / 2.54) * 72;
            if (Left > 100) {
                Left = 100;
                this.showLeft = (
                    (+this.$store.state.sheet.left / 72) *
                    2.54
                ).toFixed(2);
            }
            this.sheet.left = Left;
            this.$store.dispatch("sheetChangeLeft", Left);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.saveChange();
            this.$forceUpdate();
        }
    }
    changeRight() {
        let Right = +this.showRight;
        if (+this.showRight < 0) {
            Right = 0;
            this.showRight = "0";
            this.sheet.right = Right;
            this.$store.dispatch("sheetChangeRight", Right);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
        } else {
            Right = (+Right / 2.54) * 72;
            if (Right > 100) {
                Right = 100;
                this.showRight = (
                    (+this.$store.state.sheet.right / 72) *
                    2.54
                ).toFixed(2);
            }
            this.sheet.right = Right;
            this.$store.dispatch("sheetChangeRight", Right);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.saveChange();
        }
    }
    endDrag(e: any) {
        this.endY = e.y;
        let top = this.$store.state.sheet.top;
        let distance = this.endY - this.startY;
        if (distance > 100) {
            top = 100;
        } else {
            top += distance;
        }

        if (top < 0) {
            top = 0;
        }
        this.sheet.top = top;
        this.$store.dispatch("sheetChangeTop", top);
        localStorage.setItem("sheet", JSON.stringify(this.sheet));
        this.showTop = ((this.$store.state.sheet.top / 72) * 2.54).toFixed(2);
        this.saveChange();
    }

    endDragLeft(e: any, num: number) {
        let left = this.$store.state.sheet.left;
        let right = this.$store.state.sheet.right;
        this.endX = e.x;
        let distance = this.endX - this.startX;
        if (num === 0) {
            if (distance > 100) {
                left = 100;
            } else {
                left += distance;
            }
            if (left < 0) {
                left = 0;
            }
            this.sheet.left = left;
            this.$store.dispatch("sheetChangeLeft", left);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.showLeft = (
                (this.$store.state.sheet.left / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        } else {
            if (distance < -100) {
                right = 100;
            } else {
                right -= distance;
            }
            if (right > 100) {
                right = 100;
            }
            if (right < 0) {
                right = 0;
            }
            this.sheet.right = right;
            this.$store.dispatch("sheetChangeRight", right);
            localStorage.setItem("sheet", JSON.stringify(this.sheet));
            this.showRight = (
                (this.$store.state.sheet.right / 72) *
                2.54
            ).toFixed(2);
            this.saveChange();
        }
    }
    // 获取焦点
    selectInner(e: any) {
        this.$nextTick(() => {
            e.target.select();
        });
    }
}
